import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-main">
          {/* Logo & Description */}
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="footer-logo-text">F12IA</span>
              <span className="footer-logo-tm">™</span>
            </div>
            <p className="footer-tagline">
              L'IA code. On t'envoie les clients. Tu encaisses.
            </p>
          </div>

          {/* Links */}
          <div className="footer-links">
            <div className="footer-column">
              <h4>Légal</h4>
              <Link to="/mentions-legales">Mentions légales</Link>
              <Link to="/cgv">CGV</Link>
              <Link to="/politique-confidentialite">Confidentialité</Link>
            </div>

            <div className="footer-column">
              <h4>Contact</h4>
              <a href="mailto:contact@f12ia.com">contact@f12ia.com</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} F12IA. Tous droits réservés.
          </p>
          <div className="footer-payment">
            <span>Paiement sécurisé par</span>
            <svg className="stripe-logo" viewBox="0 0 60 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M60 12.8c0-4.23-2.05-7.57-5.98-7.57-3.95 0-6.32 3.34-6.32 7.54 0 4.97 2.81 7.48 6.85 7.48 1.97 0 3.46-.45 4.58-1.07v-3.3c-1.12.56-2.4.91-4.03.91-1.59 0-3-.56-3.18-2.5h8.02c0-.21.06-1.07.06-1.49zm-8.1-1.57c0-1.86 1.14-2.63 2.18-2.63 1.01 0 2.09.77 2.09 2.63h-4.27zm-10.47-6c-1.6 0-2.63.75-3.2 1.27l-.21-1.01h-3.61v19.21l4.1-.87.01-4.66c.59.42 1.45 1.03 2.88 1.03 2.91 0 5.57-2.34 5.57-7.51-.02-4.72-2.71-7.46-5.54-7.46zm-.97 11.48c-.96 0-1.53-.34-1.92-.77l-.02-6.07c.42-.47 1-.8 1.94-.8 1.48 0 2.51 1.66 2.51 3.81 0 2.19-1.01 3.83-2.51 3.83zM26.94 4.47l4.12-.88V.29l-4.12.87v3.31zM31.06 5.5h-4.1v14.26h4.1V5.5zM22.48 6.87l-.26-1.37h-3.55v14.26h4.1V9.7c.97-1.27 2.61-1.03 3.12-.85V5.5c-.53-.2-2.46-.56-3.41 1.37zM14.49 1.96l-4 .85-.02 13.05c0 2.41 1.81 4.19 4.22 4.19 1.34 0 2.31-.25 2.85-.53v-3.33c-.52.21-3.09.96-3.09-1.45V8.91h3.09V5.5H14.45l.04-3.54zM4.17 9.48c0-.64.53-.89 1.41-.89 1.26 0 2.85.38 4.11 1.06V5.77c-1.38-.55-2.74-.77-4.11-.77C2.22 5 0 6.74 0 9.72c0 4.62 6.36 3.88 6.36 5.87 0 .76-.66 1.01-1.59 1.01-1.37 0-3.13-.57-4.52-1.33v3.92c1.54.66 3.1.95 4.52.95 3.42 0 5.77-1.69 5.77-4.72-.02-4.99-6.37-4.1-6.37-5.94z" fill="rgba(255,255,255,0.6)"/>
            </svg>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
